import React, {useRef} from "react";
import { Box, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import logo from '../assets/tractors-main1.png';
import JobSection from "./JobSection";
import MapSection from "./MapSection";

const TitleImage = styled('img')`
    height: auto;
    width: 100vw;
    margin-bottom: 0;
`;

const Home = () => {
    const targetRef = useRef(null);

    const handleScrollToTarget = () => {
        if (targetRef.current) {
          targetRef.current.scrollIntoView({
            behavior: 'smooth', // Smooth scrolling
            block: 'start',     // Scroll to the top of the element
          });
        }
      };

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Grid container>
                <TitleImage src={logo} alt="Tractor Logo" ></TitleImage>
                <Grid item md={2} xs={12} sx={{ order: { md: 1, xs: 2 } }}>
                </Grid>
                <Grid item md={8} xs={12} sx={{ order: { md: 2, xs: 1 } }}>
                    <MapSection onScrollToTarget={handleScrollToTarget} />
                    <JobSection ref={targetRef} />
                </Grid>
                <Grid item md={2} xs={12} sx={{ order: { md: 3, xs: 3 } }}>
                </Grid>
            </Grid>
        </Box>
    )
}

export default Home;